import { render, staticRenderFns } from "./AdminData.vue?vue&type=template&id=39261821&scoped=true"
import script from "./AdminData.vue?vue&type=script&lang=js"
export * from "./AdminData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39261821",
  null
  
)

export default component.exports